import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const CONNECT_INSTREAM_TO_GAM: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation connectInstreamToGam($input: ConnectInstreamToGamInput!) {
    connectInstreamToGam(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
